import { useNavigate, useOutletContext } from 'react-router-dom'

import {
  ApprovalGroupDetailsFragment,
  ApprovalGroupRootPageDocument,
  CreateApprovalsRulesConfigurationRulesInput,
  CreateRulesConfigurationDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import {
  Form,
  rulesConfigurationsFormValues,
} from 'modules/approvals/components/RulesConfiguration/Form'

const CreateApprovalRulePage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { group } = useOutletContext<{ group: ApprovalGroupDetailsFragment }>()

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const [createRulesConfiguration] = useMutation(CreateRulesConfigurationDocument, {
    extractorFn: (data) => data.approvalsMutations.createApprovalsRulesConfiguration,
  })

  const onSuccess = (_data: rulesConfigurationsFormValues) => {
    navigate(
      navigation.approvals.approvalGroupsCategoryId.details.fullPath({
        id: group.id,
        category: group.category,
      })
    )
  }

  const domainConfigurationRules = group?.domainConfigurationRules

  const onSubmit = async (data: rulesConfigurationsFormValues) => {
    return createRulesConfiguration({
      variables: {
        name: data.name,
        isTemplate: false,
        approvalGroupId: group.id,
        flow: data.flow,
        onRulesMet: data.onRulesMet,
        category: group.category, // FIXME: Fix group type to use ApprovalsValueObjectsApprovalCategoryEnum as the category type
        rules: (data.rules || []) as CreateApprovalsRulesConfigurationRulesInput[],
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: ApprovalGroupRootPageDocument,
          variables: {
            id: group.id,
            companyId,
            category: group.category,
          },
        },
      ],
    })
  }

  const variables: rulesConfigurationsFormValues = {
    name: '',
    isTemplate: false,
    rules: [],
    onRulesMet: 'auto_approve',
    flow: null,
  }

  return (
    <Form
      action={'create'}
      variables={variables}
      domainConfigurationRules={domainConfigurationRules}
      onSubmit={(data) => onSubmit(data)}
      onSuccess={(data) => onSuccess(data)}
    />
  )
}

export default CreateApprovalRulePage
